@import '../../../../../../constants/spacing.module.less';
@import (reference) '../security.module.less';

.add-enrollment-modal-content {
  padding: @space-16;
}

.footer {
  align-items: center;
  justify-content: flex-end;
}

.verification-methods-section {
  padding: @space-16 @space-0;
}

.verification-methods {
  flex-wrap: nowrap;
}

.select-method-button-content {
  align-items: center;
  justify-content: space-between;
}

.select-method-button {
  flex: 1 0 33%;
  height: 56px;
  padding: @space-16;

  &.selected-method {
    border: 1px solid var(--blue-006FBB);
    outline: 2px solid var(--blue-006FBB);

    .selected-check-icon {
      width: 16px;
      color: var(--blue-006FBB);

      justify-content: center;
      align-items: center;
    }
  }
}

.method-icon {
  .icon(); // from '../security.module.less'
  justify-content: center;
}

.email-enrollment-input {
  padding-bottom: @space-16;
  width: 50%;
}

.phone-input-row {
  align-items: flex-end;
  justify-content: flex-start;
}

.country-code-input {
  flex: 0 0 16px;
}

.phone-verification-dropdown {
  width: fit-content;
  padding-bottom: @space-16;
}

.add-new-button {
  width: fit-content;
  align-self: flex-end;
}

.authenticator-secret {
  min-height: 345px; // roughly the height of the QR Code section
  align-items: center;
  padding: @space-16 @space-0;
}

.authenticator-instructions {
  align-self: flex-start;
}

.authenticator-code {
  padding: @space-4 @space-4 @space-4 @space-12;
  background-color: var(--grey-300);
  border-radius: 5px;
}

.consent-checkbox {
  font-size: 14px;
}

.consent-disclaimer {
  color: var(--grey-600);
  font-size: 12px;
}
